import { ChangeDetectionStrategy, Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core'

@Component({
  selector: 'lin-chat-toolbar-template',
  templateUrl: './chat-toolbar-template.component.html',
  styleUrls: ['./chat-toolbar-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatToolbarTemplateComponent {
  @Output() handleClose = new EventEmitter<void>()

  @ViewChild(TemplateRef) templateRef: TemplateRef<unknown>
}
